import { registerRootComponent } from 'expo';
import { AppRegistry } from 'react-native';
// import './src/react_trueid/trueid.js'
// import  './index.html'
import App from './App';

registerRootComponent(App);
   